import { useResponsive } from '@features/responsive';
import Heading from '@components/Heading/Heading';
import styles from '@features/loginPage/components/ActionBlock/ActionBlock.styles';
import { TImage } from '@components/typescript';
import Icon from '@components/icons/Icon';
import Button from '@components/Button/Button';
import { getSizesString } from '@utils/misc';
import RenderMedia from '@utils/RenderMedia';
import { BLANK_VIDEO_OBJECT } from '@features/cms/const';
type PropsType = {
  heading: string;
  description: string;
  descriptionPoints?: string[];
  buttonText: string;
  buttonAction: () => void;
  buttonOutlined: boolean;
  fullHeight?: boolean;
  image?: TImage;
  cy?: string;
};
const ActionBlock = ({
  heading,
  description,
  descriptionPoints = undefined,
  buttonText,
  buttonAction,
  buttonOutlined,
  fullHeight = false,
  image = undefined,
  cy = ''
}: PropsType) => {
  const {
    isNarrowerThanMobilelg
  } = useResponsive();
  const hasImage = !!(image && image.desktop);
  return <div sx={styles.blockContainer(!!fullHeight, hasImage)}>
      <div sx={styles.blockHolder(!!fullHeight, hasImage)}>
        <div sx={styles.heading}>
          <Heading h={2} headingType={4}>
            {heading}
          </Heading>
        </div>
        <p sx={styles.text(hasImage)}>{description}</p>
        {descriptionPoints && descriptionPoints.length && <div sx={styles.descriptionList}>
            {descriptionPoints.map((item: string) => <div key={item} sx={styles.descriptionSingleItem}>
                <Icon icon="Check" size="24px" />
                <p sx={styles.descriptionSingleItemText}>{item}</p>
              </div>)}
          </div>}
        <div sx={styles.voxButtonContainer}>
          <Button variant={buttonOutlined ? 'outlined' : 'default'} variantColor="dark" fullWidth={!!isNarrowerThanMobilelg} onClick={buttonAction} size="small" addSx={styles.voxButton} letterCase="lowercase" cy={cy}>
            {buttonText}
          </Button>
        </div>
      </div>
      {hasImage && <div sx={styles.imageContainer}>
          <div sx={styles.imageWrapper}>
            {RenderMedia(image, BLANK_VIDEO_OBJECT, false, undefined, heading, false, getSizesString(['100vw', '100vw', '50vw']))}
          </div>
        </div>}
    </div>;
};
export default ActionBlock;